import React from 'react';
import { useEffect } from 'react';
import { api } from '@api';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
    CHINESE_LANGUAGE_CODE_LK,
    BURMESE_LANGUAGE_CODE_LK,
} from "@constants";
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { getFingerprintData } from '@utils';
import { MESSAGE_TYPES } from '@constants';
import styled from 'styled-components';
import {
    MoreOutlined,
    LessOutlined,
} from '@assets';

const Container = styled.div`
position: absolute;
bottom: 110px;
left: 0;
width: calc(100% - 24px);
padding: 12px;
border-radius: 20px 20px 0px 0px;
background: #FFF;
`;

const Item = styled.div`
padding: 5px 12px 5px 10px;
display: inline;
background-color: #f4f4f4;
border-radius: 16px;
border: 1px solid #D66700;
cursor: pointer;
display: flex;
align-items: center;
justify-content: center;
gap: 4px;

font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #1C1C1C;

@media screen and (max-width: 375px) {
font-size: 12px;
padding: 5px 10px 5px 8px;
}

@media screen and (max-width: 320px) {
font-size: 11px;
padding: 5px 8px 5px 6px;
}
`;

const ActionButton = styled.div`
height: 32px;
padding: 0 12px 0 8px;
display: flex;
gap: 2px;
align-items: center;
justify-content: center;

border-radius: 16px;
background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
cursor: pointer;

font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #2A2A2A;
`;

const {
    AUTO_REPLY,
} = MESSAGE_TYPES;

const MIN_OPT_COUNT = 8;

const OptionsBox = ({
    optRef,
    room_id,
    loadingCallback,
    errorCallback,
    scrollToBottom,
    resetTempData,
    sendOptionSuccessCallback,
    changeOptHeight,
}) => {
    const { t } = useTranslation();
    const { userPreferedLanguage } = useSelector(state => state.app);
    const { user_id } = useSelector(state => state.auth.user);
    const [options, setOptions] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        getMessageOptions();

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (expanded || options.length < MIN_OPT_COUNT) {
            setData(options);
        }
        else {
            setData(options.slice(0, MIN_OPT_COUNT));
        }

        // eslint-disable-next-line
    }, [expanded, options]);

    useEffect(() => {
        changeOptHeight();

        // eslint-disable-next-line
    }, [data]);

    const getMessageOptions = () => {
        api
            .getMessageOptions()
            .then(({ message_options }) => {
                setOptions(message_options);
            })
            .catch(() => { });
    };

    const doPost = (payload, item) => {
        resetTempData();
        getFingerprintData()
            .then(device_info => {
                api
                    .postMessage({
                        ...payload,
                        room_id,
                        device_info,
                    })
                    .then(({ messages }) => {
                        const sent_msg = { ...messages[0], uuid: item.uuid };
                        if (payload.type === AUTO_REPLY) {
                            const reply_msg = messages[1];
                            sendOptionSuccessCallback({ reply_msg, sent_msg });
                        }
                    })
                    .catch(() => {
                        errorCallback(item);
                    });
            })
            .catch(() => { });
    }

    const sendOption = ({ content, message_option_id }) => {
        const payload = {
            type: AUTO_REPLY,
            message_option_id,
            content,
        };
        let item = makeTempItem(payload);
        loadingCallback(item);
        doPost(payload, item);
        scrollToBottom();
    }

    const makeTempItem = msg => {
        return {
            ...msg,
            sender_id: user_id,
            sent_at: moment().unix(),
            loading: true,
            uuid: uuidv4(),
        };
    }

    const getLangMsg = (opt) => {
        return userPreferedLanguage === CHINESE_LANGUAGE_CODE_LK
            ? opt.button_text_ch
            : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
                ? opt.button_text_mm
                : opt.button_text_en;
    }

    const handleActionClicked = () => {
        setExpanded(prev => !prev);
    }

    return (
        <Container ref={optRef}>
            <Row gutter={[8, 8]}>
                {data.map((opt, key) => (
                    <Col key={key}>
                        <Item
                            key={key}
                            onClick={() => sendOption({
                                content: getLangMsg(opt),
                                message_option_id: opt.message_option_id,
                            })}
                        >
                            {getLangMsg(opt)}
                        </Item>
                    </Col>
                ))}
                {options.length > MIN_OPT_COUNT &&
                    <Col>
                        <ActionButton onClick={handleActionClicked}>
                            {!expanded ? <MoreOutlined /> : <LessOutlined />}
                            {!expanded ? t("message.showMoreLabel") : t("message.showLessLabel")}
                        </ActionButton>
                    </Col>
                }
            </Row>
        </Container>
    );
}

export default OptionsBox;